import { BusinessError, EntityKind, ErrorKind, buildBusinessErrorFromError, } from '@mgdis/eu-domain';
class TiersRestAdapter {
    restHttpAdapter;
    sessionService;
    tenantId;
    /**
     * API of Tiers.
     *
     */
    constructor({ tenantId, restHttpAdapter, sessionService }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
        this.sessionService = sessionService;
    }
    /**
     * Call API: get tiers list of connected user
     *
     */
    async getAllCurrentUserTiers() {
        try {
            const res = await this.restHttpAdapter.post(`/referentiel-tiers/${this.tenantId}/tiers/mine`, {
                from: 0,
                size: 10,
                select: ['reference'],
            });
            return {
                response: res.data,
            };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.TIERS }) };
        }
    }
    /**
     * Call API: get current tiers
     *
     */
    async getCurrentTiers() {
        try {
            const tiersRef = await this.sessionService.getTiersReference();
            if (!tiersRef) {
                return {
                    error: new BusinessError(ErrorKind.BUSINESS, {
                        entity: EntityKind.TIERS,
                    }),
                };
            }
            const res = await this.restHttpAdapter.get(`/referentiel-tiers/${this.tenantId}/tiers/${tiersRef}`, {
                params: { expand: 'famille,formeJuridique' },
                headers: {
                    Accept: 'application/vnd.mgdis.tiers-3.0.0+json',
                },
            });
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.TIERS }) };
        }
    }
    async getTiersPublicSettings() {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-tiers/${this.tenantId}/admin/publicSettings?merge=true`);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
    async getTiersReferent(tiersId) {
        try {
            const res = await this.restHttpAdapter.get(`${tiersId}/referent`);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
    async getFamillesTiersCount() {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-tiers/${this.tenantId}/tiers/stats/count-by-type-famille`);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error) };
        }
    }
}
export { TiersRestAdapter };
//# sourceMappingURL=tiers-rest.adapter.js.map